"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultTimestampAccessor = exports.DefaultMeasureAccessor = exports.extractDatumFromVictoryRow = exports.undefinedToZero = exports.undefinedToNull = exports.throwIfUndefined = exports.accessorForRefOrValue = exports.accessorForReference = void 0;
var EffectiveDefinition_1 = require("./EffectiveDefinition");
var accessorForReference = function (columnReference) {
    return function (row) { return row[columnReference.column]; };
};
exports.accessorForReference = accessorForReference;
var accessorForRefOrValue = function (refOrValue) {
    if ((0, EffectiveDefinition_1.isColumnRef)(refOrValue)) {
        return (0, exports.accessorForReference)(refOrValue);
    }
    return function (row) { return refOrValue; };
};
exports.accessorForRefOrValue = accessorForRefOrValue;
var throwIfUndefined = function (accessor, message) {
    if (message === void 0) { message = 'Accessor returned undefined'; }
    return function (row) {
        var v = accessor(row);
        if (v === undefined) {
            throw new Error(message);
        }
        return v;
    };
};
exports.throwIfUndefined = throwIfUndefined;
var undefinedToNull = function (accessor) {
    return function (row) { var _a; return (_a = accessor(row)) !== null && _a !== void 0 ? _a : null; };
};
exports.undefinedToNull = undefinedToNull;
var undefinedToZero = function (accessor) {
    return function (row) { var _a; return (_a = accessor(row)) !== null && _a !== void 0 ? _a : 0; };
};
exports.undefinedToZero = undefinedToZero;
/**
 * In some victory sub components such as labels, functions need to operate on
 * rows of data that have been processed by victory, instead of `DataRow`s
 * directly. In these cases, the original `DataRow` is included under the
 * `datum` key. This helper function wraps any `ValueAccessor`, and allows it to
 * work as if passed a `DataRow` directly.
 *
 * @param accessor the `ValueAccessor` to wrap
 */
var extractDatumFromVictoryRow = function (accessor) {
    return function (row) { return accessor(row.datum); };
};
exports.extractDatumFromVictoryRow = extractDatumFromVictoryRow;
var DefaultMeasureAccessor = function (row) { return row.measure; };
exports.DefaultMeasureAccessor = DefaultMeasureAccessor;
var DefaultTimestampAccessor = function (row) { return row.timestamp; };
exports.DefaultTimestampAccessor = DefaultTimestampAccessor;
//# sourceMappingURL=Accessor.js.map